import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';

type WarRoomVoteButtonProps = {
  isUpvote?: boolean;
  isUpvoted?: boolean;
  isDownvote?: boolean;
  isDownvoted?: boolean;
  isDisabled?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'WarRoomVoteButton',
  props: {
    isUpvote: { type: Boolean, default: false },
    isUpvoted: { type: Boolean, default: false },
    isDownvote: { type: Boolean, default: false },
    isDownvoted: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { isUpvote: boolean, isUpvoted: boolean, isDownvote: boolean, isDownvoted: boolean, isDisabled: boolean };



const buttonClasses = computed(() => ({
  'war-room-vote-button': true,
  'war-room-vote-button--upvoted': props.isUpvoted,
  'war-room-vote-button--downvoted': props.isDownvoted,
  'war-room-vote-button--disabled': props.isDisabled,
}));

return { __sfc: true,props, buttonClasses }
}

})